const Help = () => {
  const helpItems = [
    {
      title: "Home Page",
      image: "/new5ca/assets/images/help/dashboard.png",
      description:
        "This home page provides a snapshot of the current state of user registrations, geographical distribution, and membership status. It includes a chart showing the number of users registered over time, a map displaying user locations, and a summary of active and inactive members.",
    },
    {
      title: "Events",
      image: "/new5ca/assets/images/help/events.png",
      description:
        "This page displays upcoming and past event information. You can click on any event to view all its details, including date, time, location, and description.",
    },
    {
      title: "News",
      image: "/new5ca/assets/images/help/news.png",
      description:
        'The News page displays news insights, and clicking on "Read More" shows all the news.',
    },
    {
      title: "Membership Plan",
      image: "/new5ca/assets/images/help/membershipplan.png",
      description:
        "Here, you can view your current membership plan and request an upgrade to access more features and benefits.",
    },
    {
      title: "View Impact",
      image: "/new5ca/assets/images/help/viewImpact.png",
      description:
        "This page allows you to view the impact of your membership, including statistics and achievements.",
    },
    {
      title: "Make Transaction",
      image: "/new5ca/assets/images/help/makeTransaction.png",
      description:
        "You can make transactions related to your membership, such as payments or donations, from this page.",
    },
    {
      title: "withdraw Request",
      image: "/new5ca/assets/images/help/withdrawForm.png",
      description:
        "This page allows you to withdraw funds or request a payout related to your membership.",
    },
    {
      title: "New Request",
      image: "/new5ca/assets/images/help/newRequest.png",
      description:
        "You can submit new requests or inquiries related to your membership or services from this page.",
    },
    {
      title: "User Profile",
      image: "/new5ca/assets/images/help/userProfile.png",
      description:
        "This page displays your user profile information, including personal details, contact information, and membership status.",
    },
    {
      title: "User List",
      image: "/new5ca/assets/images/help/userList.png",
      description:
        "You can view a list of all users, including their profiles and membership details, from this page.",
    },
    {
      title: "Recent Members",
      image: "/new5ca/assets/images/help/recentMembers.png",
      description:
        "This section displays the most recent members who have joined, along with their basic information.",
    },
    {
      title: "Timeline",
      image: "/new5ca/assets/images/help/timeline.png",
      description:
        "You can upload photos, videos, and music from the timeline page. It also displays feeds and posts.",
    },
    {
      title: "Chat",
      image: "/new5ca/assets/images/help/Chat.png",
      description:
        "You can search for members using their company name or owner name, and start chatting with them directly from the sidebar.",
    },
  ];

  return (
    <section className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card border-top border-0 border-4 border-primary">
              <div className="card-body p-5">
                <div className="card-title d-flex align-items-center">
                  <h5 className="mb-0 text-primary">Help Information</h5>
                </div>
                <hr />
                <div className="row">
                  {helpItems.map((item, index) => (
                    <div className="col-md-6 mb-4" key={index}>
                      <div className="card shadow-sm h-100">
                        <div
                          className="card-header text-white text-center"
                          style={{ backgroundColor: "#212529" }}
                        >
                          <h5 className="mb-0 text-white">{item.title}</h5>
                        </div>
                        <div className="card-body text-center">
                          <img
                            src={item.image}
                            className="img-fluid mb-3"
                            style={{ maxHeight: "200px" }}
                            alt={item.title}
                          />
                          <p className="text-justify">{item.description}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Help;
